import React from "react";

function VoteItem() {
  return <div>VoteItem</div>;
}

export default VoteItem;
